import SiteHeader from "./components/SiteHeader";
import SiteHero from "./components/SiteHero";
import HotRank from "./components/HotRank";
import LeakGrid from "./components/LeakGrid";
import MelonReview from "./components/MelonReview";
import WordCloud from "./components/WordCloud";
import AggSection from "./components/AggSection";
import ExpressFeed from "./components/ExpressFeed";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-body text-foreground-950">
      <SiteHeader />
      <main>
        <SiteHero />
        <HotRank />
        <LeakGrid />
        <MelonReview />
        <WordCloud />
        <AggSection />
        <ExpressFeed />
      </main>
      <SiteFooter />
    </div>
  );
}